<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                AR Invoice - Revison/Void Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
                <b-row>
                    <b-col lg="4">
                        <b-input-group >
                            <b-input-group-prepend><label>Ori. Invoice No.</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.invoiceno" @keyup.13.native="lkuArinvShow=true" :state="!$v.model.arinvKey.$error"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuArinvShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col lg="3">
                        <b-input-group >
                            <b-input-group-prepend><label>Ori.Invoice Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.invdate" disabled></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">
                        <b-input-group >
                            <b-input-group-prepend><label>Ori. Invoice Total</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlamtdueB4" :precision="2" disabled></my-number>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Ori. Customer</label></b-input-group-prepend>
                            <b-form-input v-model="model.custinfoB4" disabled></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Ori.Description</label></b-input-group-prepend>
                            <b-form-input v-model="model.uraianB4" disabled></b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row>
            <hr>    
              <b-row>
                <b-col lg="8">
                    <b-form-row>
                        <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.invoiceno" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Revision Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-form-row >                      
                    <b-input-group >
                        <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.custinfo" :state="!$v.model.custcode.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCustomerShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-form-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Sales Purch.Order</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.ordernumber" ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuSalesorderShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend ><label>&nbsp;</label></b-input-group-prepend>
                                <b-form-radio-group class="mt-2" v-model="model.deffered" name="radioDeffered">
                                    <b-form-radio value="0">Invoice Actual</b-form-radio>
                                    <b-form-radio value="1">UnEarned Income</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>

                        </b-col>
                    </b-form-row>                      
                    <b-input-group >
                        <b-input-group-prepend><label>Description Line#1</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian1" :state="!$v.model.uraian1.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Description Line#2</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian2" ></b-form-input>
                    </b-input-group>
                    <b-form-row>
                        <b-col cols="6" >
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice Amount</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error" disabled></b-form-select>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" ></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">   
                            <b-input-group>
                                <b-input-group-prepend><label style="width:165px !important;">Related to other Invoice #</label></b-input-group-prepend>
                                <b-form-input v-model="model.invoicereff" placeholder="Canceled/UnEarned Inc. Invoice"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                </b-col>
                <b-col lg="4">
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                    <b-input-group >
                        <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCashflow('model')" id="apKodecash">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblArLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="arLines.items"
                    :fields="arLines.fields"
                    :current-page="arLines.page"
                    :per-page="arLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(description)="data">
                            <pre>{{data.item.description}}</pre>
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(unitprice)="data">
                        {{data.item.unitprice|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(nilaippn)="data">
                        {{data.item.nilaippn|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(nilaidue)="data">
                        {{data.item.nilaidue|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editArLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delArLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                        <b-tabs card v-model="tabIndex">
                            <b-tab title="INVOICE ITEM DETAIL" active>
                                <b-row h-align="center">
                                    <b-col lg="6" class="pl-0">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Revenue Account</label></b-input-group-prepend>
                                            <b-form-select v-model="arLinesObj.salesKode" :plain="true" :options="salesAccounts" :state="!$v.arLinesObj.salesKode.$error"></b-form-select>
                                        </b-input-group>
                                        <b-input-group>
                                            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                            <b-form-textarea :rows="4" :max-rows="13" v-model="arLinesObj.description" :state="!$v.arLinesObj.description.$error" ></b-form-textarea>
                                        </b-input-group>
                                        <b-form-row>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                                <b-form-input v-model="arLinesObj.quantity" @change="calcPrice()" type="number" :state="!$v.arLinesObj.quantity.$error"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label style="width:70px; text-align:right;">Unit Size</label></b-input-group-prepend>
                                                <b-form-input v-model="arLinesObj.unitsize" ></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        </b-form-row > 
                                        <b-form-row>
                                        <b-col md="8">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Unit price</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arLinesObj.unitprice" :precision="2" :state="!$v.arLinesObj.unitprice.$error"></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="4">
                                            <b-input-group>
                                                <b-input-group-prepend><label >Discount</label></b-input-group-prepend>
                                                <b-form-input v-model="arLinesObj.disc" ></b-form-input>
                                                <b-input-group-append><span class="input-group-text"> %</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        </b-form-row >                      

                                    </b-col>
                                    <b-col lg="6" class="pl-0">                              
                                        <b-form-row>
                                            <b-col xl="10">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Amount</label></b-input-group-prepend>
                                                    <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                    </b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arLinesObj.nilai" :precision="2" disabled></my-number>
                                                </b-input-group>
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Discount</label></b-input-group-prepend>
                                                    <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                    </b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arLinesObj.nilaidisc" :precision="2" @change="calcTaxes()"></my-number>
                                                </b-input-group>
                                            </b-col>
                                        </b-form-row >                      
                                        <b-form-row>
                                            <b-col xl="10">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Net Amount</label></b-input-group-prepend>
                                                    <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                    </b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arLinesObj.nilainett" :precision="2" disabled></my-number>
                                                </b-input-group>
                                            </b-col>
                                            <b-col xl="2">                            
                                                <b-form-checkbox id="chkPPN" class="ml-1 mt-2 text-left" v-model="arLinesObj.kenappn" value=1 unchecked-value=0 @change="calcTaxes()" :state="!$v.arLinesObj.kenappn.$error">PPN(VAT)</b-form-checkbox>
                                            </b-col>
                                        </b-form-row >                      

                                        <b-form-row v-if="(arLinesObj.kenappn==1)">
                                            <b-col xl="6">
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Tarif DPP</label></b-input-group-prepend>
                                                    <b-form-input v-model="arLinesObj.dppnlain" @change="calcTaxes()"></b-form-input>
                                                    <b-input-group-append><span class="input-group-text">% </span></b-input-group-append>
                                                    <b-input-group-append><span class="pt-2"><strong> &nbsp; * Net Amount</strong> </span></b-input-group-append>
                                                </b-input-group>
                                            </b-col>
                                            <b-col xl="4">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><span class="p-2">Tarif PPN</span></b-input-group-prepend>
                                                    <b-form-input v-model="arLinesObj.ppn" @change="calcTaxes()" type="number" v-b-tooltip.hover :title="arLinesObj.ppn"></b-form-input>
                                                    <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                                </b-input-group>
                                            </b-col>
                                        </b-form-row >         
                                        <b-form-row>
                                            <b-col xl="10">                            
                                                <b-row no-gutters>
                                                    <b-col cols="8">
                                                        <b-input-group>
                                                            <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                                            <b-form-select v-model="arLinesObj.pasalpph" :plain="true" :options="lookupPPH" ></b-form-select>
                                                        </b-input-group>                                          
                                                    </b-col>
                                                    <b-col cols="4">
                                                        <b-input-group>
                                                            <b-input-group-prepend><span class="p-2">Tarif PPH</span></b-input-group-prepend>
                                                            <b-form-input v-model="arLinesObj.pph" type="number" v-b-tooltip.hover :title="arLinesObj.pph"></b-form-input>
                                                            <!-- <my-number v-model="arLinesObj.pph" :precision="2" v-b-tooltip.hover :title="arLinesObj.pph"></my-number> -->
                                                            <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                                        </b-input-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row no-gutters>
                                                    <b-col cols="1">&nbsp;
                                                    </b-col>
                                                    <b-col cols="4">
                                                        <b-input-group>
                                                            <b-form-select style="width:158px;"  v-model="calcPPh" :plain="true" :options="calcuationPPH" ></b-form-select>
                                                        </b-input-group>
                                                    </b-col>
                                                    <b-col cols="7">
                                                        <b-input-group>
                                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                                            <my-number class="form-control text-right" v-model="arLinesObj.nilaipph" :precision="2" :readonly="(calcPPh===1)"></my-number>
                                                        </b-input-group>                                          
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-form-row >         

                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="INVOICE ITEM DIMENSION">
                                <b-row>
                                    <b-col lg="8" xl="6"  class="pl-0">
                                        <v-dim :model="arLinesObj" :key="updateDimDtl" :horizontal="true"></v-dim>
                                    </b-col>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                        <b-row class="justify-content-center mt-1">
                            <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveArLines()">Update</b-button>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="5">
                        <b-row>
                            <b-button size="sm" class="ml-3" @click="addArLines" >Add Detail</b-button>                          
                            <div class="ml-2">
                                Showing {{((arLines.page - 1) * arLines.limit + 1)}}
                                to <span v-if="((arLines.page * arLines.limit)>arLines.total)">{{arLines.total}}</span>
                                    <span v-else>{{arLines.page * arLines.limit}}</span>
                                <strong> of {{arLines.total}} entries </strong>
                            </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="arLines.limit"  style="width:80px;"/>
                            </b-input-group>
                    </b-col>
                    <b-col cols="5">
                        <b-pagination
                            align="right"
                            :total-rows="arLines.total"
                            :per-page="arLines.limit"
                            v-model="arLines.page"
                        ></b-pagination>
                    </b-col>
                </b-row>
              </b-card>    
                <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                        <b-form-row>
                            <b-col lg="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>AR Posting Group</label></b-input-group-prepend>
                                    <b-form-select v-model="model.artype" :plain="true" :options="postGroups" :state="!$v.model.artype.$error"></b-form-select>
                                </b-input-group>
                            </b-col>
                            <b-col lg="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>Sales / AE</label></b-input-group-prepend>
                                    <b-form-input  v-model="model.SalesEx" ></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-form-row>                      
                        <b-form-row>
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>No. Faktur Pajak</label></b-input-group-prepend>
                                    <b-form-input v-model="model.nofaktur" :state="!$v.model.nofaktur.$error"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col lg="5">
                                <b-input-group >
                                    <b-input-group-prepend><label >Tgl. Faktur Pajak</label></b-input-group-prepend>
                                    <b-form-input v-model="model.tglfaktur" type="date" :state="!$v.model.tglfaktur.$error"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-form-row>               
                        <b-row v-if="(model.matauang !== uanguser)">
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label >Exch. Rate <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number  class="form-control text-right" separator="," v-model="model.kursPPN" :state="!$v.model.kursPPN.$error"></my-number>
                            </b-input-group>
                            </b-col>
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: right !important;">Kurs Pajak <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{uanguser}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="model.kursPPN"  :state="!$v.model.kursPPN.$error"></my-number>
                                </b-input-group>
                            </b-col>
                        </b-row>                      
                        <b-row>
                            <b-col lg="7">
                                <b-input-group >
                                    <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                        <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="model.totalpph" :precision="2" disabled></my-number>
                                    <b-form-checkbox id="chkGrossUp" class="ml-1 mt-2" v-model="model.grossup" value=1 unchecked-value=0>Gross Up</b-form-checkbox>
                                </b-input-group>
                            </b-col>
                            <b-col lg="5">
                                <b-input-group >
                                    <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Bentuk Pembayaran</label></b-input-group-prepend>
                                    <b-form-select v-model="model.pack_name" :plain="true" :options="paymentForms" class="mr-2">
                                    </b-form-select>
                                </b-input-group>
                            </b-col>
                        </b-row>   

                    </b-col>
                    <b-col lg="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Gross</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlgross" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px;"  v-model="model.calcDisc" :plain="true" :options="calcuationDisc" ></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" :readonly="(model.calcDisc===1)"></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Netto</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px;"  v-model="model.calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlvat" :precision="2" :readonly="(model.calcVAT===1)"></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                            </b-input-group>
                        </div>
                    </b-col>
                </b-row>
        </b-card>
        <b-modal v-model="lkuArinvShow" size="lg" :hide-footer="true" title="List of AR Invoice"  :key="model.CustName" :centered="true">
            <lku-arinv @click="onSelectLkuArinv" :customer="model.CustName"></lku-arinv>
        </b-modal>        
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuSalesorderShow" size="lg" :hide-footer="true" title="List of Sales Order" :centered="true">
            <lku-salesorder @click="onSelectLkuSo" :customer="model.custinfo" :customer_id="model.customer_id"></lku-salesorder>
        </b-modal>        
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
                <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData" typeacc="IN"></lku-cashflow>
        </b-modal>        
    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
      .input-group {
          .input-group-prepend {
              label {
                  width: 110px !important;
              }
          }
      }

    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuArinv from "../lookup/lkuArinvirgin";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuSalesorder from "../lookup/lkuSalesOrder";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import arinvrevision from "../../apis/arinvrevision";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredUnless, decimal, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber,  vDim, lkuArinv,lkuCustomer, lkuSalesorder, lkuCashflow},
  mixins: [validationMixin],
  validations: {
        model: {
            arinvKey: { required },
            custinfoB4: { required },
            uraianB4: { required },
            ttlamtdueB4: { required },
            custcode: { required },
            uraian1: { required },
            invdate: { required },
            artype: { required },
            // kodecash: { required },
            matauang: { required },
                nofaktur: {required : (function() {
                    if ((this.model.ttlvat || 0) == 0) {
                        return true;
                    } else if ((this.model.nofaktur || '')==''){
                        return false;
                    } else return true;
                })},
                tglfaktur: {required : (function() {
                    if ((this.model.ttlvat || 0) == 0) {
                        return true;
                    } else if (!(this.model.tglfaktur)){
                        return false;
                    } else return true;
                })},
            kursPPN: { numeric, required:requiredUnless('localCurrency') }
        },
        arLinesObj: {
            salesKode: { required },
            description: { required },
            quantity: { decimal },
            unitprice: { decimal },
            nilai: { decimal },
            ppn: { decimal },
            kenappn: { required },
            pph: { decimal },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        horizontal:true,
        lkuCashflowData:{},
        lkuCashflowShow: false,
        lkuCashflowCaller:'model',        
        lkuArinvShow: false,
        lkuCustomerShow: false,
        lkuSalesorderShow: false,
        lkuSoData:{},
        updateDimHdr:false,
        updateDimDtl:true,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        postGroups:[],
        salesAccounts:[],
        currency:[{value:'IDR',text:'IDR'}],
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Auto)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[],paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
        YesNo :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
        model:{
            arinvKey: '',
            custinfoB4: '',
            uraianB4: '',
            ttlamtdueB4: 0,
            custcode: '',ordernumber:'',
            uraian1: '',
            invdate: '',
            artype: '',
            kodebank: '',
            kodecash: '',
            matauang: 'IDR',pack_name:'STANDARD',
            nofaktur: '', tglfaktur: '',
            totalinv: 0,
            kursPPN: 1,
            nilaippn:0,ttlvat:0,deffered:0,proforma:0, 
            DimTableKey:'', ttlgross:'', ttlamtdue:'', calcVAT:1,calcDisc:1},
        arLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "description",
                    label: "Description",
                },
                {
                    key: "NamaSale",
                    label: "Revenue Account"
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:90px",
                },
                {
                    key: "unitprice",
                    label: "Unit price",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilai",
                    label: "Amount NETT",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaippn",
                    label: "VAT",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaidue",
                    label: "Amount DUE",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        arLinesObj:{unitsize:'', DimTableKey:'', 
            salesKode: '',
            description: '',
            quantity: 1,
            unitprice: 0,
            nilai: 0,
            ppn: 0,
            kenappn: 0,
            pasalpph: '',
            pph: 0,
            nilaipph:0
        },
        tabIndex:0
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidArLines() {
      this.$v.arLinesObj.$touch();
      return this.$v.arLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    noPPN(){
        return (this.model.ttlvat == 0);
    },
    localCurrency(){
        return (this.model.matauang == this.uanguser);
    },
    unitprice(){
        return this.arLinesObj.unitprice;
    },
    pasalpph(){
        return this.arLinesObj.pasalpph;
    },    
    salesKode(){
        return this.arLinesObj.salesKode;
    },    
    tarifPPh(){
        return this.arLinesObj.pph;
    },    
    disc(){
        return this.arLinesObj.disc;
    },    
    discvalue(){
        return this.arLinesObj.nilaidisc;
    },    
    disctotal(){
        return this.model.ttldiskon;
    },    
    vattotal(){
        return this.model.ttlvat;
    },    
  },
  watch: {
    unitprice: function(newval) {
        // console.log('unitprice :',newval);
        // setTimeout(() => {
            this.calcPrice();
        // }, 100);
    },    
    pasalpph: function(newval) {
        const item = this.lookupPPH.find(p => p.value==newval);
        if (item) {
            this.arLinesObj.pph=item.pph;
            setTimeout(() => {
                this.calcTaxes();
            }, 100);
        }
    },    
    tarifPPh: function(newval) {
            this.calcPrice();
    },    
    disc: function(newval) {
        this.arLinesObj.nilaidisc = parseFloat((this.arLinesObj.nilai || 0)) * parseFloat(this.arLinesObj.disc) / 100;;        
        this.calcTaxes();
    },    
    discvalue: function(newval) {
            this.calcTaxes();
    },    
    disctotal: function(newval) {
        this.model.ttlnetto=this.model.ttlgross-this.model.ttldiskon;
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    },    
    vattotal: function(newval) {
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    },    
    salesKode: function(newval) {
        const item = this.salesAccounts.find(p => p.value==newval);
        this.arLinesObj.NamaSale=item.text;
        if (newval=="N/A") {
            this.arLinesObj.unitsize='';
            this.arLinesObj.quantity = 0;
            this.arLinesObj.kenappn = 0;
            this.arLinesObj.dppnlain = 100;
            this.arLinesObj.ppn = 0;
            this.arLinesObj.nilaipph = 0;
            this.arLinesObj.nilainett =0;
            this.arLinesObj.unitprice=0;
            this.arLinesObj.pasalpph='NO WHT';
        }

    },    
    noPPN: function(newval) {
        if (newval) {
            this.model.nofaktur='';
            this.model.tglfaktur='';
        }
    },    
  },
  created: async function(){

      if (this.$route.params.arinvreKey)  {
          toastr.info('Loading ARDetail, please wait')
          try {
            const [a,b,c,d,f,data] = await Promise.all([arinvrevision.postgroup(),arinvrevision.pasalpph(),arinvrevision.currency(),arinvrevision.salesAccount(),arinvrevision.paymentform(), arinvrevision.detail(this.$route.params)]) ;
            this.postGroups = a;
            this.lookupPPH = b;
            this.currency = c;
            this.salesAccounts = d;
            this.paymentForms = f;

            // const data = await arinvrevision.detail(this.$route.params);  
            const row = data[0][0];
            this.saveEnabled=(row.posting === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
            row.invdueda = row.invdueda ? moment(row.invdueda).format('YYYY-MM-DD') : '';
            row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.arLines.items = data[1];
            this.arLines.total=this.arLines.items.length;
            this.calcTotalDtl();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;            
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        const [a,b,c,d,f] = await Promise.all([arinvrevision.postgroup(),arinvrevision.pasalpph(),arinvrevision.currency(),arinvrevision.salesAccount(),arinvrevision.paymentform()]) ;
        this.postGroups = a;
        this.lookupPPH = b;
        this.currency = c;
        this.salesAccounts = d;
        this.paymentForms = f;
        this.model.tanggal = moment().format('YYYY-MM-DD');
      }
  },
  methods: {
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        this[this.lkuCashflowCaller].cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        this[this.lkuCashflowCaller].kodecash = lkuData.selected.kodecash;
        this[this.lkuCashflowCaller].namacash = lkuData.selected.namacash;
        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
            this.model.kodecash = lkuData.selected.kodecash;
            this.model.namacash = lkuData.selected.namacash;
        }
        this.lkuCashflowShow=false;
    },
    calcPrice : function() {
        this.arLinesObj.nilai = parseFloat(this.arLinesObj.quantity) * parseFloat((this.arLinesObj.unitprice || 0));
        this.calcTaxes();
    },
    calcTaxes : function() {
        this.arLinesObj.nilaidisc = (this.arLinesObj.nilai) ? this.arLinesObj.nilaidisc : 0; 
        this.arLinesObj.nilainett = this.arLinesObj.nilai - this.arLinesObj.nilaidisc;
        this.arLinesObj.dpp = parseFloat(this.arLinesObj.nilainett) * parseFloat(this.arLinesObj.dppnlain) / 100;
        this.arLinesObj.ppn = this.arLinesObj.ppn || 10;
        if (this.arLinesObj.kenappn == 1) {
            this.model.grossup = 0;
            this.arLinesObj.nilaippn = (parseFloat(this.arLinesObj.ppn,0)/100) * this.arLinesObj.dpp;
        } else {
            // this.arLinesObj.dpp = 0;
            // this.arLinesObj.ppn = 10;
            this.arLinesObj.nilaippn = 0;
        }
        if (this.model.grossup == 1)
            this.arLinesObj.dpp = this.arLinesObj.dpp * (100 / (100 - this.arLinesObj.pph));

        this.arLinesObj.nilaidue = this.arLinesObj.nilainett + this.arLinesObj.nilaippn;

        this.arLinesObj.nilaipph = (this.arLinesObj.nilaipph) ? this.arLinesObj.nilaidisc : 0; 
        if (this.calcPPh == 1)
            this.arLinesObj.nilaipph = this.arLinesObj.dpp * this.arLinesObj.pph / 100;
        
        this.$forceUpdate();
    },
    async onSelectLkuArinv(_selected) {
            const data = await arinvrevision.detailvirgin(_selected);
            const row = data[0][0];
            row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
            row.invdueda = row.invdueda ? moment(row.invdueda).format('YYYY-MM-DD') : '';
            row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.asal=_selected.asal;
            this.model.custinfoB4=row.custinfo;
            this.model.uraianB4=row.uraian;
            this.model.ttlamtdueB4=row.ttlamtdue;

            this.arLines.items = data[1];
            this.calcTotalDtl();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;            

            this.lkuArinvShow=false;
    },
    onSelectLkuCustomer: async function (_selected) {
        this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.custcode = _selected.CustCode;
        this.model.customer_id = _selected.customer_id;
        this.lkuCustomerShow=false;
    },
    // async onSelectLkuSo(_selected) {
    //     this.model.ordernumber = _selected.nomor;
    //     this.model.custcode = _selected.Sell2Cust;
    //     this.model.custinfo = _selected.custinfo;
    //     this.model.artype = (_selected.postgrp || '').trim();
    //     this.model.matauang = _selected.matauang;
    //     this.model.ttlamtdue = _selected.nilaidue;
    //     this.model.chargeable = _selected.chargeable;
    //     this.model.nilaidpp = _selected.dpp;
    //     this.model.ttlvat = _selected.nilaippn;
    //     this.model.DimTableKey = _selected.DimTableKey;
    //     try {
    //         const data = await arinv.salesOrder({ salesHdrKey: _selected.salesHdrKey }) ;
    //         console.log('SO Detail ; ', data);
    //         const row = data[0][0];
    //         this.model.calcVAT = this.model.calcVAT || 1;
    //             var lines = data[1];
    //             this.arLines = [];
    //             this.model.ttlnetto = 0;
    //             this.model.ttlamtdue = 0;
    //             this.model.totalpph = 0;
    //             let nilaippn= 0;
    //             let newLine;
    //             for (let i = 0; i < lines.length; i += 1) {
    //                 newLine = {};
    //                 for (let key in lines[i]) {
    //                     newLine[key] = lines[i][key];
    //                 }
    //                 this.model.ttlnetto = this.model.ttlnetto + (newLine.nilai || 0);
    //                 nilaippn += (newLine.nilaippn || 0);
    //                 this.model.ttlamtdue = this.model.ttlnetto + (this.model.nilaippn || 0);
    //                 this.model.totalpph = this.model.totalpph + (newLine.nilaipph || 0);

    //                 newLine.lineno = i + 1;
    //                 newLine.description = lines[i].description + ' ' + (lines[i].itemname || '');
    //                 newLine.NamaSale = (lines[i].salesKode) ? (lines[i].NamaSale || '') : '-- Please select ! -- ';

    //                 this.arLines.push(newLine);
    //             }
    //             if (this.model.calcVAT == 1) this.model.nilaippn = 0;
            
    //     } catch (error) {
    //         this.isLoading=false;
    //         if (error.message) {
    //             toastr.error(error.message,'ERROR MESSAGE',10000);
    //         } else {
    //             toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
    //         }
    //     }
    //     this.lkuSalesorderShow=false;
    // },
    onSelectLkuSo(_selected) {
        this.model.salesHdrKey=_selected.salesHdrKey;
        this.model.ordernumber = _selected.nomor;
        // this.model.mediaorder=_selected.nomor;
        // this.model.juduliklan=_selected.uraian;
        this.model.matauang=_selected.matauang;
        this.model.pack_name=_selected.jenisbayar;
        this.model.keteranganbayar=_selected.keteranganbayar;
        this.model.custinfo = _selected.CustName.trim()+ ' | '+ _selected.CustCode.trim();
        this.model.customer_id = _selected.customer_id;
        this.model.customer_name = _selected.CustName.trim();
        this.model.Advertiser=_selected.Advertiser;
        this.model.brand=_selected.brand;
        this.model.kategori=_selected.kategori;
        this.model.accexec=_selected.SalesExCode;
        this.updateDimDtl2Hdr(_selected);
        this.lkuSoShow=false;
        // this.lkuSoData=_selected;
    },      
    closeArLines: function(){
        const opened= this.arLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addArLines : function () {
        this.closeArLines();
        const obj={_showDetails:true};
        this.arLines.selected = obj;
        this.arLinesObj.unitzise=''; 
        this.arLinesObj.DimTableKey=''; 
        this.arLinesObj.salesKode= '';
        this.arLinesObj.description= '';
        this.arLinesObj.quantity= 1;
        this.arLinesObj.unitprice= 0;
        this.arLinesObj.nilai= 0;
        this.arLinesObj.ppn= 10;
        this.arLinesObj.nilaidisc=0;
        this.arLinesObj.disc=0;        
        this.arLinesObj.unitsize='EACH';
        this.arLinesObj.quantity = 1;
        this.arLinesObj.unitprice=0;
        this.arLinesObj.dppnlain = 100;
        this.arLinesObj.ppn = 10;
        this.arLinesObj.nilaipph = 0;
        this.arLinesObj.nilainett =0;
        this.calcPPh=1;
        this.updateDimHdr2Dtl(this.arLinesObj);
        this.arLines.items.push(obj);
        this.arLines.total=this.arLines.items.length;
        setTimeout(() => {
                const bfore = this.arLines.page;
                const after =Math.ceil((this.arLines.total)/this.arLines.limit);
                if (bfore != after){
                    this.arLines.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.arLines.total} items`,'Line/Detail',10000);
                }
        }, 100);    
    },
    editArLines : function (obj,callback) {
        this.closeArLines();
        this.arLines.selected = obj;
            this.arLinesObj.unitzise=''; 
            this.arLinesObj.DimTableKey=''; 
            this.arLinesObj.salesKode= '';
            this.arLinesObj.description= '';
            this.arLinesObj.quantity= 1;
            this.arLinesObj.unitprice= 0;
            this.arLinesObj.nilai= 0;
            this.arLinesObj.ppn= 10;
            this.arLinesObj.kenappn= 0;
            this.arLinesObj.pasalpph= '';
            this.arLinesObj.pph= 0;
            this.arLinesObj.nilaidisc=0;
            this.arLinesObj.disc=0;        
        for (var key in obj) {
            this.arLinesObj[key] = obj[key] || 0;
        }
        // this.arLinesObj.salesKode=obj.salesKode||'';
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.arLinesObj[dim.value] = obj[dim.value];
                this.arLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.arLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        this.tabIndex=0;
        callback();
    },
    delArLines: function (index) {
        if (index > -1) {
            // this.arLines.items.splice(index, 1);
            const posisi = (this.arLines.page-1)*this.arLines.limit;
            this.arLines.items.splice(posisi+index, 1);
        }
        this.arLines.total=this.arLines.items.length;
        this.calcTotalDtl();
    },
    saveArLines: async function (callback) {
        // this.arLinesObj.nilainett = parseFloat(this.arLinesObj.nilai);
        // if (this.arLinesObj.kenappn == 1) {
        //     this.arLinesObj.dpp = parseFloat(this.arLinesObj.nilainett) * parseFloat(this.arLinesObj.dppnlain) / 100;
        //     // this.arLinesObj.ppn = 10;
        // } else {
        //     this.arLinesObj.dpp = 0;
        //     this.arLinesObj.ppn = 0;
        // }
        // this.arLinesObj.nilaippn = 0.1 * this.arLinesObj.dpp;
        // this.arLinesObj.nilaidue = this.arLinesObj.nilainett + this.arLinesObj.nilaippn;
        // this.arLinesObj.nilaipph = this.arLinesObj.dpp * this.arLinesObj.pph / 100;
        this.arLinesObj.pasalpph= this.arLinesObj.pasalpph || 'N/A';
        this.calcPrice();
        if (this.invalidArLines) {
            console.log('validation : ', this.$v.arLinesObj);
            console.log('model obj : ',this.arLinesObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
           if (this.tabIndex===0) {
                for (var key in this.arLinesObj) {
                    this.arLines.selected[key] = this.arLinesObj[key];
                }
                this.calcTotalDtl();
               this.tabIndex=1;
               return
           }
            let datadim=this.arLinesObj;
            datadim.TableName = 'arinvdt';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.arLinesObj) {
                        this.arLines.selected[key] = this.arLinesObj[key];
                    }
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.arLines.selected[dim.value] = datadim[dim.value];
                            this.arLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.arLines.total=this.arLines.items.length;
                    this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtl();
                    this.arLines.selected._showDetails=false;
                    if (callback) callback();
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg, "ERROR MESSAGE",10000);
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    save: async function () {
        console.log('Save Clicked');
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.model.totalinv = this.model.totalinv || 0;
        this.saveEnabled=false;      
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else if (Math.abs(this.model.totalinv - parseFloat(this.model.ttlamtdue))>0.5)  {
            toastr.error('[Total Invoice] not Balance with [Total Detail Invoice]', "ERROR MESSAGE",10000);
            this.saveEnabled=true;            
        } else {
            try {
                this.model.TableName = 'arinvtt';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PO;
                    this.model.arinvKey = this.model.arinvKey || '';
                    this.model.invoiceno = this.model.invoiceno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    row.invdate = moment(row.invdate).format('YYYY-MM-DD');
                    row.invdueda = (row.invdueda) ? moment(row.invdueda).format('YYYY-MM-DD'):row.invdate ;
                    row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : undefined;
                    
                    let lineno=1;
                    let newArLines = this.arLines.items.reduce((newArr, item) => {
                        if ((item.salesKode || '') != '') {
                            item.lineno = lineno;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);

                    row.lines = newArLines;
                    await arinvrevision.insert(row);
                    toastr.success("Complete successfully", "Save AR");
                    this.close();
                } else {
                    this.saveEnabled=true;            
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE",10000);
                }
            } catch (error) {
                this.saveEnabled=true;            
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save AR Error",10000);                
            }

        }
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.arLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtl: function () {
        // this.model.calcVAT = this.model.calcVAT || 1;
        // this.model.calcDisc = this.model.calcDisc || 1;
        let nilaidpp = 0;
        let ttlvat = 0;
        let ttlgross = 0;
        let ttldiskon = 0;
        // let ttlamtdue = 0;
        let totalpph = 0;
        let totaldpp = 0;
        this.arLines.items.forEach((trx)=> {
            if (trx.salesKode) {
                nilaidpp += (trx.dpp || 0);
                ttlgross += (trx.nilai || 0);
                ttldiskon += (trx.nilaidisc || 0);
                ttlvat += (trx.nilaippn || 0);
                // ttlamtdue = ttlnetto + (nilaippn || 0);
                totalpph += parseFloat(trx.nilaipph || 0);
            }
        });
        this.model.ttlgross = ttlgross;
        this.model.ttldiskon = (ttlgross) ? this.model.ttldiskon : 0;
        if (this.model.calcDisc == 1){
            this.model.ttldiskon = ttldiskon;
        }
        this.model.ttlnetto =this.model.ttlgross-this.model.ttldiskon;
        this.model.ttlvat = (this.model.ttlnetto) ?  this.model.ttlvat: 0;
        if (this.model.calcVAT == 1){
            this.model.nilaidpp = nilaidpp;
            this.model.ttlvat = ttlvat;
        }
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        this.model.totalpph = totalpph;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'receivable.arinvrevisionfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.arinvrevision'});
          router.push("home");
      }
    }
  }
};
</script>
